import React from "react"
import { Card, Grid, Typography } from "@mui/material"

const ActivePositionItem = ({ details, setCurrentAP, goToChat, icon, isMobile }) => {
  const { book, status } = details
  const { title, grade, subject, isBundle } = book

  return (
    <Card
      variant="outlined"
      onClick={() => setCurrentAP(details)}
      sx={{
        width: "90%",
        borderColor: status === "matched" ? "primary.main" : "",
        mx: "5%",
        my: "1vh",
        height: "auto",
        px: "1vw",
        py: 1,
        cursor: "pointer",
        "&:hover": { backgroundColor: status === "matched" ? "hover.main" : "lightgray" },
        // "&:hover": { backgroundColor: status === "matched" ? "rgba(152, 227, 156, 0.4)" : "lightgray" },
      }}>
      <Grid container alignItems="center">
        <Grid item xs={isMobile ? 2 : 1}>
          {icon}
        </Grid>
        {isMobile ? (
          <Grid item xs={10}>
            <Typography align="left">{title}</Typography>
          </Grid>
        ) : (
          <Grid item xs={status === "matched" ? (isBundle ? 8.5 : 4) : isBundle ? 11 : 6.5}>
            <Typography align="left">{title}</Typography>
          </Grid>
        )}
        {!isBundle && !isMobile && (
          <>
            <Grid item xs={1}>
              <Typography align="right">{grade}. Kl.</Typography>
            </Grid>
            <Grid item xs={3.5}>
              <Typography align="right">{subject}</Typography>
            </Grid>
          </>
        )}
        {status === "matched" && !isMobile && (
          <Grid item xs={2.5} onClick={() => goToChat()}>
            <Typography align="right" sx={{ color: "primary.main", textDecoration: "underline" }}>
              Zum Chat
            </Typography>
          </Grid>
        )}
      </Grid>
    </Card>
  )
}

export default ActivePositionItem
